export { c as chunk, e as elementOf, f as filterDistictByPattern, a as findOrAdd, b as findOrDefault, p as padEnd, d as padStart } from '../lib/array-Dac_UCE_.mjs';

function containEqual(a, b, comparator = (ae, be) => ae === be) {
  if (a.length !== b.length) {
    return false;
  }
  return a.every((ae) => b.some((be) => comparator(ae, be))) && b.every((be) => a.some((ae) => comparator(ae, be)));
}
function diff(a, b, comparator = (ae, be) => ae === be) {
  const aNotInB = a.filter((ae) => !b.some((be) => comparator(ae, be)));
  const bNotInA = b.filter((be) => !a.some((ae) => comparator(ae, be)));
  const combined = [...aNotInB, ...bNotInA];
  return [aNotInB, bNotInA, combined];
}

function groupBy({
  values,
  bykey,
  shape,
  comparer
}) {
  const valKeyName = shape && shape.values || "values";
  const keyName = shape && shape.key || "key";
  const res = [];
  values.forEach((value) => {
    const key = value[bykey];
    let resultValues = res.find(
      (resVal) => comparer ? comparer(resVal[keyName], key) : resVal[keyName] === key
    );
    if (!resultValues) {
      resultValues = {};
      resultValues[keyName] = key;
      resultValues[valKeyName] = [];
      res.push(resultValues);
    }
    resultValues[valKeyName].push(value);
  });
  return res;
}

export { containEqual, diff, groupBy };
/*                              */
